'use client';

import dynamic from 'next/dynamic';
import { Component, type ErrorInfo, type FC, type PropsWithChildren } from 'react';

import { logger } from '@lichtblick/logger';

import { CONNECTION_ERROR_MESSAGE } from './FunnelEmbed.content';
import { type FunnelState } from './updateState.types';

const InnerFunnelEmbed = dynamic(() => import('./FunnelEmbed.inner').then(({ InnerFunnelEmbed }) => InnerFunnelEmbed));

class ErrorSafeFunnelEmbed extends Component<any, { hasError: boolean }> {
  private latestState?: FunnelState;
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('EMBEDDED_SOLAR_FUNNEL: FunnelEmbed crashed - fallback is rendered', errorInfo, error);
  }

  private readonly syncLatestState = (state: FunnelState) => {
    this.latestState = state;
  };
  render() {
    const initialState =
      this.state.hasError && this.latestState
        ? { ...this.latestState, errors: { generic: CONNECTION_ERROR_MESSAGE, ...this.latestState?.errors } }
        : undefined;

    return <InnerFunnelEmbed initialState={initialState} onStateChange={this.syncLatestState} />;
  }
}

export const FunnelEmbed: FC = () => <ErrorSafeFunnelEmbed />;
